import {Component, ViewChild} from '@angular/core';
import {Nav, Platform} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {TranslateService} from "@ngx-translate/core";
import {DataService} from "../services/data-service";

@Component({
  templateUrl: 'app.html'
})

export class AppEngineer {
  @ViewChild('root_content') root_nav: Nav;

  rootPage: any = "HomePage";

  constructor(public platform: Platform,
              private splashScreen: SplashScreen,
              private statusBar: StatusBar,
              public translate: TranslateService,
              public data: DataService) {

    translate.addLangs(['en-gb', 'zh-cn']);
    translate.setDefaultLang('en-gb');

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts